import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { useControl } from 'react-map-gl';

export default function DrawControl(props) {
  useControl(
    () => new MapboxDraw({
      ...props,
      modes: {
        ...MapboxDraw.modes,
        simple_select: { ...MapboxDraw.modes.simple_select, dragMove() {} },
        ...(props.modes || {}),
      },
    
    }),
    ({ map }) => {
      map.on('draw.create', props.onCreate);
      map.on('draw.update', props.onUpdate);
      map.on('draw.delete', props.onDelete);
    },
    ({ map }) => {
      map.off('draw.create', props.onCreate);
      map.off('draw.update', props.onUpdate);
      map.off('draw.delete', props.onDelete);
    },
    {
      position: props.position
    }
  );

  return null;
}